import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [appSettings, setAppSettings] = useState(null);

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/app-settings");
      setAppSettings(data);
    } catch {
      setAppSettings(null);
    }
  }, []);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadSettings();
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, [loadSettings]);

  useEffect(() => {
    refreshMe();
    const onExpired = () => setUser(false);
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, [refreshMe]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  const role = user?.role;
  const value = {
    user, setUser, refreshMe, logout, appSettings, loadSettings,
    canWrite: role === "admin" || role === "payroll_officer",
    isAdmin: role === "admin",
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
